module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v(" 更多\n                    ")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "查询信息",
      "width": "90%",
      "visible": _vm.queryDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.queryDialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "系部",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeOption('dept')
      }
    },
    model: {
      value: (_vm.queryForm.deptCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "deptCode", $$v)
      },
      expression: "queryForm.deptCode"
    }
  }, _vm._l((_vm.comboOption.dept), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "专业",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.changeOption('major')
      }
    },
    model: {
      value: (_vm.queryForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "majorCode", $$v)
      },
      expression: "queryForm.majorCode"
    }
  }, _vm._l((_vm.comboOption.major), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "班级",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.classCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "classCode", $$v)
      },
      expression: "queryForm.classCode"
    }
  }, _vm._l((_vm.comboOption.class), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_vm._v("查 询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重 置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('div', {
    style: ({
      'height': _vm.divHeight - 110 + 'px',
      'overflow': 'auto'
    }),
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有实习信息记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学号：")]), _vm._v(_vm._s(item.stuCode))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("姓名：")]), _vm._v(_vm._s(item.stuName))])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [_c('el-button', {
      attrs: {
        "type": "info",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.detail(item)
        }
      }
    }, [_vm._v("详情")])], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2), _vm._v(" "), (_vm.detailDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "详情",
      "visible": _vm.detailDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialogVisible = $event
      }
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.stuName) + " - " + _vm._s(_vm.selectRowData.stuCode) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "系部"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.deptName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专业"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.majorName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "班级"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.className) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习推荐类型"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.parseType(_vm.selectRowData)) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习单位名称"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.unitName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习岗位名称"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.postName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习开始时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.beginTime) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习结束时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.endTime) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习薪资"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.salary) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人姓名"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.unitContactsName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人职务"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.unitContactsDuty) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人电话"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.unitContactsTel) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人邮箱"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.unitContactsEmail) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位地址"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.unitAddress) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "岗位是否对口"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.parseSf(_vm.selectRowData.counterpart)) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否安排带教"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.parseSf(_vm.selectRowData.teaching)) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否提供住宿"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.parseSf(_vm.selectRowData.putUp)) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入学前户籍信息"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.censusRegisterInfo) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习期间居住地址"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.residentialAddress) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "家庭电话"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.homeTel) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生手机号"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.stuPhone) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生邮箱"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.stuEmail) + "\n                    ")])], 1)], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60165a42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/practice/infoMobile.vue
// module id = 1846
// module chunks = 502